import { CdkPortalOutletAttachedRef, ComponentPortal, Portal, TemplatePortal } from '@angular/cdk/portal';
import { AfterViewInit, Component, ComponentRef, EventEmitter, Injector, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { GiftCardCartCustomizationComponent } from './gift-card-cart-customization/gift-card-cart-customization.component';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { Attributes } from '../../shared-core/models/cart-data.model';


@Component({
  selector: 'app-cart-customization',
  templateUrl: './cart-customization.component.html',
  styleUrls: ['./cart-customization.component.scss']
})
export class CartCustomizationComponent implements AfterViewInit, OnChanges {
  @ViewChild('cartCustomizationModal') cartCustomizationModal: ModalDirective;
  @Input() public recordId: string = null;
  @Input() public itemAttributes: Attributes = null;
  @Input() public webcode: string;
  @Input() public show = false;
  @Output() showChange = new EventEmitter<boolean>();

  public portal: Portal<any>
  private bodyElement: HTMLElement;

  constructor(private _toaster: ToastService) { }

  ngAfterViewInit(): void {
    this.bodyElement = document.querySelector('body');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.show?.currentValue === 'true' || changes.show?.currentValue === true) {
      this.initPortal();
    }
  }

  public initPortal(): void {
    this.bodyElement.style.overflow = 'hidden';
    const injector = Injector.create({
      providers: [
        { provide: 'webCode', useValue: this.webcode },
        { provide: 'recordId', useValue: this.recordId },
        { provide: 'itemAttributes', useValue: this.itemAttributes }
      ]
    });

    this.portal = new ComponentPortal(GiftCardCartCustomizationComponent, null, injector);
    this.cartCustomizationModal.show();
  }

  public onPortalAttached(attachedRef: CdkPortalOutletAttachedRef) {
    const ref = attachedRef as ComponentRef<any>;

    const hiddenEvent = ref.instance['hidden'] as EventEmitter<any>;

    hiddenEvent.subscribe(({ addedToCart, updateEvent }) => this.hideModal(addedToCart, updateEvent));
  }

  public hideModal(addedToCart: boolean, updateEvent: boolean): void {
    this.bodyElement.style.overflow = 'inherit';
    this.cartCustomizationModal.hide();
    this.showChange.emit(false);
    if (addedToCart === true && updateEvent === false) {
      this._toaster.success('Redirecting you to your cart. Please wait...', 'Added to Cart');
      var base_url = window.location.origin;
      window.location.assign(`${base_url}/cart`);
    }
  }
}
